import { Form } from '@medely/ui-kit';
import React from 'react';
import { createSpecialtiesPayload, getSpecialtiesPreSelectedIds } from '../utils';
import { SpecialtiesForm } from './components/SpecialtiesForm';
import { PositionWithSpecialtiesProps, ProfessionalSpecialtiesProps } from './interface';
import { specialtiesFormSchema } from './specialtiesFormSchema';
import { useSpecialtiesMutations } from './mutations';

type ValuesType = {
  specialty_ids: number[];
};

type SpecialtiesViewProps = {
  positionWithSpecialtiesInfo?: PositionWithSpecialtiesProps | null;
  professionalSpecialties?: ProfessionalSpecialtiesProps;
  onBackClick: (params: undefined) => void;
};

export const SpecialtiesView = ({
  positionWithSpecialtiesInfo,
  professionalSpecialties,
  onBackClick,
}: SpecialtiesViewProps) => {
  const { submitSpecialtiesInfo, isSpecialtiesLoading } = useSpecialtiesMutations();

  const preSelectedSpecialties = getSpecialtiesPreSelectedIds({
    positionWithSpecialtiesInfo,
    professionalSpecialties,
  });

  const defaultValues = {
    specialty_ids: preSelectedSpecialties || [],
  };

  const options = positionWithSpecialtiesInfo?.specialties
    ?.filter(({ active }) => active)
    .map((specialty) => {
      return {
        value: specialty.id,
        label: specialty.label as string,
      };
    });

  const handleSubmit = (values: ValuesType) => {
    const payloadInfo = createSpecialtiesPayload({
      preSelectedSpecialties,
      selectedSpecialties: values.specialty_ids,
    });

    if (payloadInfo.hasNoPayloadChange) {
      return onBackClick(undefined);
    }

    submitSpecialtiesInfo(payloadInfo.payload, {
      onSuccess: () => {
        onBackClick(undefined);
      },
    });
  };

  return (
    <Form handleSubmit={handleSubmit} schema={specialtiesFormSchema} defaultValues={defaultValues}>
      <SpecialtiesForm
        positionName={positionWithSpecialtiesInfo?.display_name}
        onBackClick={onBackClick}
        isSpecialtiesLoading={isSpecialtiesLoading}
        options={options}
        preSelectedSpecialties={preSelectedSpecialties}
      />
    </Form>
  );
};
